<template>
  <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 512 512" fill="currentColor">
    <!--!Font Awesome Free 6.7.2 by @fontawesome - https://fontawesome.com License - https://fontawesome.com/license/free Copyright 2024 Fonticons, Inc.-->
    <path
        d="M505 359c9.4 9.4 9.4 24.6 0 33.9l-80 80c-15 15-41 4.5-41-17V416h-58.8a12 12 0 0 1 -8.8-3.8l-70.6-75.6 53.3-57.1L352 336h32v-40c0-21.4 25.9-32 41-17l80 80zM12 176h84l52.8 56.6 53.3-57.1-70.6-75.6A12 12 0 0 0 122.8 96H12c-6.6 0-12 5.4-12 12v56c0 6.6 5.4 12 12 12zm372 0v40c0 21.5 26 32 41 17l80-80c9.4-9.4 9.4-24.6 0-33.9l-80-80C409.9 24 384 34.6 384 56V96h-58.8a12 12 0 0 0 -8.8 3.8L96 336H12c-6.6 0-12 5.4-12 12v56c0 6.6 5.4 12 12 12h110.8c3.3 0 6.5-1.4 8.8-3.8L352 176h32z"/>
  </svg>
</template>
<script>
export default {
  name: 'randomSolidIcon',
}
</script>
